import {
  type BuyerMaterialSpecificationsAdminListResponse,
  type BuyerMaterialSpecificationsListResponse,
  useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve,
  useCurrentUser,
} from 'api';

type HookProps = {
  tradeCompanyId: number;
};

const isAdminResponse = (
  data: BuyerMaterialSpecificationsListResponse
): data is BuyerMaterialSpecificationsAdminListResponse => {
  if (!data?.results?.length) return true;

  return 'notes' in data.results[0];
};

export const useGetBuyerMaterialSpecificationsAsAdmin = ({ tradeCompanyId }: HookProps) => {
  const { data: user } = useCurrentUser();
  const {
    data,
    isPending,
    error: apiError,
    ...rest
  } = useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve<BuyerMaterialSpecificationsAdminListResponse>(
    tradeCompanyId,
    undefined,
    {
      query: {
        enabled: user?.is_superuser,
      },
    }
  );

  const error =
    data && !isAdminResponse(data)
      ? Error(
          'Expected admin response (BuyerMaterialSpecificationsAdminListResponse) but received buyer response. ' +
            'This hook should only be used by admin users.'
        )
      : apiError;

  return {
    data: (data?.results || []).sort((a, b) => (a.material.title < b.material.title ? -1 : 1)),
    error: error,
    isPending,
    ...rest,
  };
};
